import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { DatesPopover } from './DatesPopover';
import { filterIconChipStyle } from '../Filter.style';
import dayjs from 'dayjs';
import { Chip } from '../../Chip';
export const formatDateTemp = (date, locale) => {
    if (date) {
        if (typeof date === 'string')
            return new Date(date).toLocaleString(locale || 'fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' });
        else if (date instanceof Date)
            return date.toLocaleString(locale || 'fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' });
        else
            return dayjs(date).toString();
    }
    else
        return '';
};
export const Dates = ({ onSendDatesRange, label, title, dataQa, defaultValue, disableFuture, labelsDateFilter, minDate, maxDate, paginationData, filterDates, setFilterDates }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const filterHasOneDate = (filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateBefore) || (filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateAfter) || ((filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateDebut) && (filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateEnd));
    const handleOpen = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const open = Boolean(anchorEl);
    const handleDelete = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onSendDatesRange({});
        setFilterDates(undefined);
    };
    const locale = labelsDateFilter.locale;
    const labelBefore = labelsDateFilter.titleDateBefore;
    const labelAfter = labelsDateFilter.titleDateAfter;
    const labelRange = labelsDateFilter.titleDateRange;
    const chipLabel = (label) => {
        let labelChip = label;
        const min = dayjs.isDayjs(minDate) ? minDate : dayjs(minDate);
        if (disableFuture && filterDates && !Object.values(filterDates).every((d) => dayjs(d).isBefore(dayjs())))
            return labelChip;
        if (minDate && filterDates && !Object.values(filterDates).every((d) => dayjs(d).isAfter(min)))
            return labelChip;
        if (filterHasOneDate && filterDates && Object.values(filterDates).every((d) => dayjs(d).isValid()))
            labelChip += ' | ';
        if ((filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateBefore) && dayjs(filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateBefore).isValid())
            labelChip += `${labelBefore} ${formatDateTemp(filterDates.dateBefore, locale)}`;
        else if ((filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateAfter) && dayjs(filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateAfter).isValid())
            labelChip += `${labelAfter} ${formatDateTemp(filterDates.dateAfter, locale)}`;
        else if ((filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateDebut) &&
            (filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateEnd) &&
            dayjs(filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateDebut).isValid() &&
            dayjs(filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateEnd).isValid() &&
            dayjs(filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateDebut).diff(dayjs(filterDates === null || filterDates === void 0 ? void 0 : filterDates.dateEnd)) < 0)
            labelChip += `${labelRange.from} ${formatDateTemp(filterDates.dateDebut, locale)} ${labelRange.to} ${formatDateTemp(filterDates.dateEnd, locale)}`;
        return labelChip;
    };
    useEffect(() => {
        if ((paginationData === null || paginationData === void 0 ? void 0 : paginationData.changePageOnFiltering) && (paginationData === null || paginationData === void 0 ? void 0 : paginationData.setPage)) {
            paginationData.setPage(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterDates]);
    return (React.createElement(Box, { "data-qa": dataQa },
        React.createElement(Chip, { "data-qa": `${dataQa}-chip`, label: chipLabel(label), onClick: handleOpen, variant: "outlined", selected: filterDates !== undefined, icon: filterHasOneDate ? (React.createElement(CancelIcon, { onClick: handleDelete, "data-qa": `${dataQa}-iconCancel` })) : (React.createElement(AddCircleIcon, { "data-qa": `${dataQa}-iconAdd`, sx: filterIconChipStyle })) }),
        React.createElement(DatesPopover, { title: title, label: label, dataQa: dataQa, defaultValue: defaultValue, disableFuture: disableFuture, open: open, anchorEl: anchorEl, setAnchorEl: setAnchorEl, filterDates: filterDates, setFilterDates: setFilterDates, onSendDatesRange: onSendDatesRange, labelsDateFilter: labelsDateFilter, maxDate: maxDate, minDate: minDate })));
};
